/**
 * Single-flight: chamadas concorrentes enquanto uma execução está em andamento
 * recebem a MESMA promise (uma só execução real). Ao terminar (sucesso ou
 * erro), a próxima chamada dispara uma execução nova.
 *
 * Uso: refresh de sessão do painel. O refresh token é ROTACIONADO a cada
 * POST /auth/refresh; dois refreshes paralelos com o mesmo cookie fazem o
 * segundo cair em "Sessão expirada" (token já revogado), apagar o cookie novo
 * e mandar o usuário para /login — o loop de autenticação.
 */
export function singleFlight<T>(fn: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null
  return () => {
    if (!inFlight) {
      inFlight = fn().finally(() => {
        inFlight = null
      })
    }
    return inFlight
  }
}
